import React, { useEffect, useState, useRef } from "react";
import {
  patientMeetingStatusOngoing,
  checkAppointmentStatusOngoing,
} from "../api/apiHandler";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { RejoinPopup } from "../modal/rejoinPopup";
import { AppointmentReminderPopup } from "../modal/appointmentReminderPopup";
const MeetingRejoin = ({}) => {
  const [rejoin, setRejoin] = useState(false);
  const [appointmentReminder, setAppointmentReminder] = useState(false);
  const [meetindData, setMeedingData] = useState({});
  const lastRouteRef = useRef(null);
  const popupShownRef = useRef(false);
  let location = useLocation();
  console.log(location.pathname);
  const navigate = useNavigate();
  const handleJoinMeeting = (patient_data) => {
    const navigateTo = localStorage.getItem("meeting_room");
    console.log(navigateTo, "nasvsigatseTo", patient_data);

    if (
      parseInt(localStorage.getItem("user_login_type_role")) == 2 ||
      parseInt(localStorage.getItem("user_login_type_role")) == 4
    ) {
      const joinMeetingObj = {
        meeting_id: patient_data.meeting_information[0]?.meeting_id,
        appointment_id: patient_data?.id,

        user_id: localStorage.getItem("user_id"),
        name: localStorage.getItem("user_name"),
        email: localStorage.getItem("user_email"),
        role: parseInt(localStorage.getItem("user_login_type_role")),
        start_meeting: 0,
        patient_id: patient_data?.patient_information?.id,
        patient_f_fullName:
          patient_data?.patient_information?.patient_full_name,
        ongoing_meet: true,
        meetType: meetindData?.aiName,
      };
      console.log("joinMeetingObj", joinMeetingObj);
      if (!navigateTo) {
        navigate("/meeting", { state: joinMeetingObj });
      } else {
        navigate(navigateTo, { state: joinMeetingObj });
      }
    } else {
      const joinMeetingObj = {
        meeting_id: patient_data?.meeting_information[0]?.meeting_id,
        appointment_id: patient_data?.id,

        user_id: localStorage.getItem("user_id"),
        name: localStorage.getItem("user_name"),
        email: localStorage.getItem("user_email"),
        role: parseInt(localStorage.getItem("user_login_type_role")),
        start_meeting: 0,
        ongoing_meet: true,
        meetType: meetindData?.aiName,
      };
      navigate("/meeting", { state: joinMeetingObj });
    }
  };

  useEffect(() => {
    const allowedRoutes = [
      "/meeting",
      "/meetingmini",
      "/meetingo3mini",
      "/meeting-trsln",
      "/meeting-trspt",
      "/meeting-single-mic",
      "/doctor/starpilot",
    ];

    if (!allowedRoutes.includes(location.pathname)) {
      if (lastRouteRef.current !== location.pathname) {
        lastRouteRef.current = location.pathname;
        popupShownRef.current = false;
      }

      if (popupShownRef.current) return;

      const loginType = parseInt(localStorage.getItem("user_login_type_role"));

      const checkMeetingStatus = async () => {
        const response =
          loginType === 2 || loginType === 4
            ? await patientMeetingStatusOngoing({})
            : await checkAppointmentStatusOngoing({});

        const result = JSON.parse(response);
        console.log("workingressssjoin", result);
        setMeedingData({});

        if (result.code === parseInt(process.env.REACT_APP_SUCCESS)) {
          setMeedingData(result?.data?.patient_data);
          setRejoin(true);
          popupShownRef.current = true;
        }
      };

      checkMeetingStatus();
    }
  }, [location.pathname]);

  return (
    <>
      <RejoinPopup
        rejoin={rejoin}
        setRejoin={setRejoin}
        handleJoinMeeting={handleJoinMeeting}
        meetindData={meetindData}
      />
      <AppointmentReminderPopup
        appointmentReminder={appointmentReminder}
        setAppointmentReminder={setAppointmentReminder}
      />
    </>
  );
};

export default MeetingRejoin;
